import Header from "../components/Header";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

import "./styles.css"

export default function ContactUs() {
  return (
    <div className="ContactUs">
      <Header></Header>
      <Contact></Contact>
      <Footer></Footer>
    </div>
  );
}
